<template>
  <div class="table">
    <div class="container">
      <!--=========查询模块END================-->
      <el-row class="action-btn-row">
        <el-button size="mini" type="primary" @click="addRow" v-acl="SaveCategory">{{$t('common.addNew')}}</el-button>
      </el-row>
      <!--=========数据列表================-->
      <el-table max-height="435" :data="tableData" ref="tableData" border highlight-current-row class="table">
        <el-table-column show-overflow-tooltip prop="bigName" :label="$t('spm.bigName')">
          <template slot-scope="scope">
            <el-input v-if="scope.row.showOperator" v-model="scope.row.bigName" maxlength="100"></el-input>
            <span v-else>{{ scope.row.bigName }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="score" :label="$t('spm.specUpload')">
          <template slot-scope="scope">
            <el-input v-if="scope.row.showOperator && scope.row.type==='add'" v-model="scope.row.score" type="number"></el-input>
            <span v-else>{{ scope.row.score }}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="statusI18n" :label="$t('common.operation')">
          <template slot-scope="scope">
            <el-button class="btn" size="mini" v-acl="SaveCategory" type="primary" @click="edit(scope.row)">{{$t('common.edit')}}</el-button>
            <el-button class="btn" size="mini" v-acl="SaveCategory" type="danger" @click="deleteRow(scope.row,scope.$index)">{{$t('common.del')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-acl="SaveCategory" style="padding-top: 15px;text-align: center;">
        <el-button size="mini" type="primary" @click="saveOrUpdate">{{$t('common.saveDraft')}}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { apiService } from "@/api/spm/spm-genera";
import commonFunction from "@/utils/dataTableUtils"
import { Message } from "element-ui";

export default {
  name: 'spm-genera',
  data() {
    return {
      tableData: []
    }
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      apiService.search().then((res) => {
        this.tableData = res.data;
      });
    },
    //操作当前行
    edit(row) {
      this.$set(row, 'showOperator', true)
    },
    //新增一行
    addRow(row) {
      this.tableData.push({ bigName: null, score: null, showOperator: true, type: 'add' })
    },
    //批量保存和修改
    saveOrUpdate: function () {
      const data = []
      for (const item of this.tableData) {
        // if (item.showOperator) {
        if (!item.bigName || !item.score) {
          Message({ message: this.$t("visitPlan.noEmpty"), type: "warning" });
          return
        }
        data.push(item)
        // }
      }
      if (data.length > 0) {
        apiService.toAddOrUpdate(data).then((res) => {
          if (res.data.code === '200') {
            Message({ message: this.$t('common.operateSuccess'), type: "success" });
            this.showDialog = false;
            this.queryData();
          } else {
            Message({ message: res.msg, type: "error" });
          }
        });
      } else {
        Message({ message: this.$t('spm.savedData'), type: "warning" });
      }
    },
    deleteRow: function (row, index) {
      //请确认是否删除!
      this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        cancelButtonClass: 'el-button--primary',
        confirmButtonClass: 'el-button--primary',
        type: 'warning'
      }).then(() => {
        //页面移除
        // if (row.type === 'add') {
        for (let i = 0; i < this.tableData.length; i++) {
          if (index === i) {
            this.tableData.splice(i, 1);
          }
        }
        /*} else {
            //    数据库删除
            apiService.deleteById(row.categoryId).then((res) => {
                if (res.data.code === '200') {
                    Message({message: this.$t('common.delSuccess'), type: "success"});
                    this.queryData();
                } else {
                    Message({message: res.meta.msg, type: "error"});
                    this.queryData();
                }
            });
        }*/
      }).catch(() => {

      });
    },

  },
  extends: commonFunction
}
</script>
<style scoped>

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
